import React from 'react'
import i18n from '~/i18n'

import Callout from '~/Common-Objects/Callout'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icon from '~/Common-Objects/UI/Icon'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'

import PosterSmall from '~/assets/images/setup/video-poster-small.png'

const SalesCallout = ({ onPosterClick, onClose }) => {
    return (
        <Callout.Wrapper onClose={onClose}>
            <Callout.Splash>
                <img
                    src={PosterSmall}
                    alt='Video Demonstration of Transpond'
                    onClick={onPosterClick}
                    data-ph='sales-open-video-modal'
                />
            </Callout.Splash>
            <Callout.Content>
                <SquareChip className='square-chip-purple'>{i18n.t('setup:callout.sales.tag')}</SquareChip>
                <div>
                    <h4>{i18n.t('setup:callout.sales.title')}</h4>
                    <p>{i18n.t('setup:callout.sales.body')}</p>
                </div>
                <ButtonNew
                    variant='darkGhost'
                    size='s'
                    iconRight={<Icon name='arrow-right' />}
                    href='https://calendly.com/transpondsales/transpond-overview'
                    target='_blank'
                    postHogTag='sales-schedule-call'
                >
                    {i18n.t('setup:callout.sales.button-text')}
                </ButtonNew>
            </Callout.Content>
        </Callout.Wrapper>
    )
}

export default SalesCallout
